// extracted by mini-css-extract-plugin
export default {"quantity":"QuantityBtn_quantity__vp2kw","icon":"QuantityBtn_icon__bX8AC"};